import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '../../utils/cn';

type InlineIconProps = {
  icon: LucideIcon;
  className?: string;
  size?: 'sm' | 'md';
  title?: string;
};

const sizeClasses: Record<NonNullable<InlineIconProps['size']>, string> = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
};

export const InlineIcon: React.FC<InlineIconProps> = ({
  icon: Icon,
  className,
  size = 'sm',
  title,
}) => {
  return (
    <span className={cn('inline-flex translate-y-[1px] items-center', className)}>
      <Icon
        className={cn(sizeClasses[size])}
        strokeWidth={2}
        aria-hidden={!title}
      />
      {title ? <span className="sr-only">{title}</span> : null}
    </span>
  );
};

